/** @format */
import React from 'react';
import { useState } from 'react';
import { toFilterVOS } from 'components/FilterPod';
import { useEffect } from 'react';
import { Empty, FilterPod, LoadingPage, PaginationReport } from 'components';
import { Box, Grid } from '@mui/material';
import { CustomerItem } from './components';
import InitFilters from './constans/InitFilters';
import Services from './services';
import { generateData } from './components/Utils';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction } from 'utility';

const COUNT_DATA_PER_PAGE = 12;
const customersList = () => {
    const [customers, setCustomers] = useState([]);
    const [filters, setFilters] = useState(InitFilters);
    const [currentPage, setCurrentPage] = useState(1);

    const [loading, setLoading] = useState(false);
    const actionsList =
        getDynamicObjectAction([
            'followersListFinancialPage',
        ])
    // --HOOKS--//

    const [openFilterDialog, setOpenFilterDialog] = useState(false);
    const handleCloseFilterDialog = () => setOpenFilterDialog(false);

    useEffect(() => {
        if (actionsList['followersListFinancialPage']) {
            getList();
            paginationOnChange({
                page: currentPage === 0 ? 1 : currentPage,
                pageSize: 5,
                pageNumber: currentPage === 0 ? 0 : currentPage - 1,
                changeData: true,
            });
        }
    }, [currentPage]);


    // --API--//
    const getList = async (f = filters, isChangeFilter = false) => {
        try {
            setLoading(true);
            const newFilters = [...f];
            // Handle Order By

            const params = {
                page: isChangeFilter ? 0 : (currentPage - 1),
                size: COUNT_DATA_PER_PAGE,
                id: newFilters[0]?.value,
                cellPhoneNumber: newFilters[1]?.value,
                userId: newFilters[2]?.value,

            };



            const res = await Services.getClients(params);


            let list = [];

            if (res.result?.length > 0) {
                list = generateData(res.result, {
                    page: currentPage - 1,
                    size: COUNT_DATA_PER_PAGE,
                });
            }
            setCustomers(list);



            setLoading(false);

        } catch (error) {
            setLoading(false);
        }
    };

    // --OTHER FUNCTIONS--//




    // تابع برای تغییر وضعیت انتخاب همه ردیف‌ها
    const paginationOnChange = async (param) => {
        if (param?.changeData) {
            // صفحه جاری در این بخش ست میش
            setCurrentPage(param?.page == 0 ? 1 : param?.page);
        }
    };

    const onFiltersChange = (newFilters) => {
        setFilters(newFilters);
        setCurrentPage(1);
        getList(newFilters, true);

    };


    return (
        <>
            <Grid item xs={12}>
                <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
                    <FilterButton
                        setOpenFilterDialog={setOpenFilterDialog}
                        filters={filters}
                    />
                </Box>
                <Box>
                    <FilterPod
                        filters={filters}
                        onChange={onFiltersChange}
                        openFilterDialog={openFilterDialog}
                        setOpenFilterDialog={setOpenFilterDialog}
                        handleCloseFilterDialog={handleCloseFilterDialog}
                    />
                </Box>
            </Grid>
            {loading ? <LoadingPage /> : null}
            {customers?.length === 0 && !loading ? <Empty /> : null}
            <Grid container spacing={2}>
                {!loading
                    ? customers?.map((v, k) => (
                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <CustomerItem
                                key={k}
                                firstName={v?.firstName ? v?.firstName : '-'}
                                lastName={v?.lastName ? v?.lastName : '-'}
                                phoneNumber={v?.phoneNumber ? v?.phoneNumber :'-'}
                                userId={v?.userId}
                                id={v?.id}
                            />
                        </Grid>
                    ))
                    : null}
            </Grid>
            {!loading ? (
                <Grid justifyContent="center" container style={{ marginTop: 16 }}>


                    <PaginationReport
                        currentPage={currentPage}
                        onChange={paginationOnChange}
                        currentLength={customers?.length}
                        totalCountAll={12}
                    />
                </Grid>
            ) : null}
        </>
    );
};

export default customersList;

